import cx from 'classnames';
import { CheckCircle, CodeCircle } from 'education-icons';
import React from 'react';

import { useCodingPropsSelector } from '../context';
import { useCodingStore } from '../state';
import { useGetMessage } from './hooks';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './coding-problem__verdict.module.scss';

export function CodingVerdictResult() {
    const selectedTest = useCodingStore((s) => s.selectedTest);

    const attempt = useCodingPropsSelector((p) => p.attempt);
    const showCorrectAnswers = useCodingPropsSelector((p) => p.showCorrectAnswers);
    const message = useGetMessage();

    if (showCorrectAnswers) {
        return null;
    }
    const result = attempt?.markers?.result[selectedTest];
    const isCorrect = result?.answer_status;
    if (typeof isCorrect === 'undefined') {
        return null;
    }

    const results = attempt && Object.values(attempt.markers?.result || {});
    const allCorrect = results && results.length > 0 && results.every((r) => r.answer_status);
    if (isCorrect && !allCorrect) {
        // если текущий тест правильный, но в целом задача не решена, сообщение не показываем
        return null;
    }

    if (!message) {
        return null;
    }

    return (
        <div className={cx(styles.verdict, allCorrect ? styles.verdict_success : styles.verdict_error)}>
            <div className={styles.verdict__icon}>{allCorrect ? <CheckCircle /> : <CodeCircle />}</div>
            {message}
        </div>
    );
}
